/**
 * Proposed sidebar entries for the purchasing feature — a contribution file
 * CLAUDE-A merges into the route registry; nothing self-registers.
 * Permission strings are the exact route-policy names.
 */
import {
  ClipboardList,
  PackageCheck,
  Settings2,
  ShoppingCart,
  Sparkles,
  Truck,
} from "lucide-react";

import type { NavEntry } from "@/app-shell/route-registry";

export const purchasingNavEntries: NavEntry[] = [
  {
    path: "/purchasing",
    labelKey: "nav.purchasing",
    icon: ShoppingCart,
    children: [
      {
        path: "/purchasing/purchase-orders",
        labelKey: "purchasing.nav.purchaseOrders",
        icon: ClipboardList,
        permission: "purchasing.purchase_order.read",
      },
      {
        path: "/purchasing/grns",
        labelKey: "purchasing.nav.goodsReceipts",
        icon: PackageCheck,
        permission: "purchasing.grn.read",
      },
      {
        path: "/purchasing/landed-costs",
        labelKey: "purchasing.nav.landedCosts",
        icon: Truck,
        permission: "purchasing.landed_cost.read",
      },
      {
        path: "/purchasing/reorder-suggestions",
        labelKey: "purchasing.nav.reorderSuggestions",
        icon: Sparkles,
        permission: "purchasing.reorder_suggestion.read",
      },
      {
        path: "/purchasing/supplier-items",
        labelKey: "purchasing.nav.supplierItems",
        icon: PackageCheck,
        permission: "purchasing.supplier_item.read",
      },
      {
        path: "/purchasing/settings",
        labelKey: "purchasing.nav.settings",
        icon: Settings2,
        permission: "purchasing.config.read",
      },
    ],
  },
];
